import { NAV_LINKS, SITE } from "@/data/content";
import { Logo } from "@/components/decor";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-navy-950 pb-10 pt-16 text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div className="max-w-sm">
            <Logo light sub />
            <p className="mt-5 text-sm leading-relaxed text-white/55">
              An independent knowledge and reference platform for India's infrastructure sector.
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-x-12 gap-y-3 sm:grid-cols-1" aria-label="Footer">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`footer-link-${l.href.replace("#", "")}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId(l.href);
                }}
                className="text-sm text-white/65 transition-colors hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-12 border-t border-white/10 pt-8">
          <p className="max-w-2xl text-xs leading-relaxed text-white/40">{SITE.footerNote}</p>
          <p className="mt-4 text-label uppercase text-white/35">
            © {new Date().getFullYear()} Infra Digest. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
